import { pageTitle } from "../PageTitle";
import HeaderOne from "../Header/HeaderOne";
import FooterOne from "../Footer/FooterOne";
import aiAccounting from "./../../assets/images/banner/solutions-banner.jpg";
import cloudera from "./../../assets/images/cloudera-service.png";
import { Link } from "react-router-dom";

const Data_Engineering = () => {
  pageTitle("Data Engineering");

  return (
    <>
      <HeaderOne></HeaderOne>
      <div
        className="ai-overlay-wrapper"
        style={{ backgroundImage: `url(${aiAccounting})` }}
      >
        {/* <img src={aiAccounting} alt="AI Operations" className="main" /> */}

        <div className="ai-overlay">
          <h2 className="rpa-af-title mt-0 mb-2">Data Engineering</h2>
          <p className="featuring">
            <img
              src="static/media/cloudera-partner-badge.bea6d1f0f7f1dfc2b1c8.jpg"
              alt="cloudera"
              className="feature-logo"
            />
          </p>
        </div>
      </div>

      <section class="siw-rpa-section">
        <div class="siw-rpa-container-data-engineering container">
          <div class="siw-rpa-content">
            <span class="siw-rpa-tag">Data Engineering Services</span>

            <div class="siw-rpa-text">
              <p>
                We deliver end-to-end Data Engineering solutions designed to
                meet enterprise needs. Our services help organizations build
                scalable, secure, and analytics-ready data platforms. We support
                deployments across both on-premises and cloud environments,
                ensuring flexibility.<br></br>
                Our solutions enable reliable data ingestion, transformation,
                and management from multiple sources. We provide data
                governance, quality controls, and operational best practices for
                enterprise datasets. Our platforms support real-time analytics,
                AI, ML, and business intelligence to drive actionable insights
              </p>
            </div>
          </div>

          <div className="siw-rpa-cta">
            <h4
              style={{
                textAlign: "center",
                color: "rgb(230, 233, 55)",
              }}
            >
              Let’s Build Your Data Platform<br></br>
            </h4>
            <p>
              Whether you’re modernizing your data lake, moving to the cloud, or
              enabling real-time analytics, we help you turn data into trusted,
              actionable intelligence.
            </p>
            <h4>
              Contact us{" "}
              <a href="tel:+6590059743" style={{ color: "rgb(230, 233, 55)" }}>
                +65 9005 9743
              </a>{" "}
              to discuss your Data Engineering requirements
            </h4>
            <a href="/contact" className="siw-rpa-btn">
              <i className="bi bi-calendar-week btn-icon"></i>
              SCHEDULE A MEETING
            </a>
          </div>
        </div>
      </section>
      <section className="container">
        <h5 className="data-engineering-sub-title">
          Cloudera Data Engineering
        </h5>
        <p style={{ padding: "10px 0" }}>
          We design and operate robust enterprise data lakes using Cloudera
          technologies to support analytics, AI, and regulatory workloads.
        </p>
        <ul className="data-engineering-list">
          <li>
            Architect and operate Cloudera-based enterprise data lakes
            supporting analytics, AI/ML, and regulatory workloads.
          </li>
          <li>
            Build and automate ETL pipelines using Spark SQL, Hive, and Sqoop
            across Raw, Clean, and Foundation zones.{" "}
          </li>
          <li>
            Lead data lake migrations and end-to-end data flow automation for
            enterprise analytics platforms.{" "}
          </li>
          <li>
            Design secure AI/ML pipelines on Cloudera AI with multi-user
            collaboration and governed access.{" "}
          </li>
          <li>
            Develop optimized Hive tables on Parquet datasets to support
            high-performance analytics and ML workloads.{" "}
          </li>
          <li>
            Administer and tune large-scale Hadoop clusters, Spark jobs, and ETL
            pipelines in regulated environments.{" "}
          </li>
          <li>
            Optimize platform performance through small file resolution, query
            tuning, SRE collaboration, and AWS S3 migration.{" "}
          </li>
        </ul>

        <h5 className="data-engineering-sub-title">AWS Data Engineering</h5>

        <p style={{ padding: "10px 0" }}>
          We build cloud-native data platforms on AWS to support modern
          analytics and compliance-driven workloads.
        </p>

        <ul className="data-engineering-list">
          <li>
            Design and implement ETL pipelines using AWS Glue and PySpark to
            ingest, cleanse, normalize, and curate data into Amazon S3 data lake
            zones.
          </li>
          <li>
            Automate large-scale data processing on AWS EMR, optimizing Spark
            jobs using partitioning and columnar formats such as Parquet.
          </li>
          <li>
            Integrate AWS Glue Data Catalog with Amazon Athena to enable ad-hoc
            SQL analytics without manual data preparation.
          </li>
          <li>
            Develop interactive dashboards using Amazon QuickSight for business
            insights.
          </li>
          <li>
            Implement secure data governance and compliance controls, including
            S3 bucket policies, IAM role-based access, Glue crawler permissions,
            and Athena query auditing via AWS CloudTrail.
          </li>
          <li>
            Extract and prepare regulatory datasets (MAS) and generate reusable
            data assets using AWS CloudFormation, Lambda, and Amazon S3.
          </li>
        </ul>
        <h5 className="data-engineering-sub-title">
          Streaming & Real-Time Data Platforms
        </h5>

        <p style={{ padding: "10px 0" }}>
          We design real-time data streaming architectures to support
          operational monitoring, analytics, and event-driven systems.
        </p>

        <ul className="data-engineering-list">
          <li>
            Build Spark Streaming (PySpark) ingestion pipelines to consume data
            from Kafka, transform it, and load it into Hive and enterprise data
            lakes.
          </li>
          <li>
            Develop real-time monitoring dashboards for mobile and internet
            banking platforms.
          </li>
          <li>
            Design and implement Apache Kafka event streaming pipelines,
            including SQL Server source integration using Debezium CDC
            connectors.
          </li>
          <li>
            Perform in-stream transformations using ksqlDB and deliver
            denormalized data to data warehouses via SQL Server sink connectors.
          </li>
          <li>
            Implement Avro-based message serialization to ensure schema
            consistency and compatibility.
          </li>
          <li>
            Establish CI/CD pipelines, data flow automation, and streaming data
            governance for enterprise banking operations.
          </li>
        </ul>
      </section>
      <section className="data-engineering-highlight">
        <div className="data-engineering-container container">
          {/* LEFT CONTENT CARD */}
          <div className="data-engineering-card data-engineering-card-main">
            <h2 className="data-engineering-title">Why Choose Us</h2>

            <ul className="data-engineering-list">
              <li>
                Deep expertise in banking, regulatory, and enterprise data
                platforms
              </li>
              <li>
                Proven experience with Cloudera, AWS, and Kafka ecosystems
              </li>
              <li>Strong focus on security, scalability, and performance</li>
              <li>
                Automation-first approach to reduce operational risk and cost
              </li>
              <li>
                End-to-end ownership from ingestion to analytics and AI
                enablement
              </li>
            </ul>

            <div className="container">
              <div className=" de-category ">
                <div className="row">
                  <div className="col-lg-6 col-md-12">
                    <li>
                      {" "}
                      <Link
                        to="/blog-dataPipeline"
                        target="_blank"
                        className="blinking"
                      >
                        <i className="icon-04"></i>Data Pipeline Automation
                      </Link>
                    </li>
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <li>
                      {" "}
                      <Link
                        to="/Big-Data-Pipeline"
                        target="_blank"
                        className="blinking"
                      >
                        <i className="icon-04"></i>Scalable Data Architecture
                      </Link>
                    </li>
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <li>
                      {" "}
                      <Link
                        to="/blog-Data-Quality"
                        target="_blank"
                        className="blinking"
                      >
                        <i className="icon-04"></i> Data Quality Management{" "}
                      </Link>
                    </li>
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <li>
                      {" "}
                      <Link
                        to="/blog-Analytics-Tool"
                        target="_blank"
                        className="blinking"
                      >
                        <i className="icon-04"></i> Integration with Analytics
                        Tools
                      </Link>
                    </li>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* RIGHT TRUST CARD */}
      {/* <div className="data-engineering-card data-engineering-card-trusted col-lg-4 col-12">
            <h4 className="data-engineering-trusted-title">
              Trusted By <br /> Industry Leader
            </h4>

            <div className="data-engineering-logos">
              <img
                src="static/media/cloudera-partner-badge.bea6d1f0f7f1dfc2b1c8.jpg"
                alt="cloudera"
              />
              <img src={cloudera} alt="cloudera" />
            </div>
          </div> */}

      {/* <section className="data-eng-section">
        <div className="container">
          <div className="row align-items-center">
 
            <div className="col-lg-8 col-md-12">
              <div className="data-eng-content">
                <h2 className="data-eng-title">
                  Modern Data Engineering with{" "}
                  <span>Cloudera Data Platform</span>
                </h2>

                <p>
                  Cloudera Data Platform is an enterprise-grade hybrid data
                  platform that unifies data engineering, data warehousing, and
                  advanced analytics to deliver faster, more reliable insights
                  across on-premise and cloud environments.
                </p>

                <p>
                  At <span className="SiW">SiW</span>, we leverage Cloudera’s
                  powerful ecosystem to support data engineering, machine
                  learning, and business intelligence use cases—without
                  introducing silos across tools or workflows.
                </p>

                <p>
                  With Cloudera, your data stays continuously up to date through
                  automated pipelines, scheduling, and event-driven processing,
                  enabling scalable, secure, and flexible analytics with minimal
                  operational overhead.
                </p>
              </div>
            </div>

      
            <div className="col-lg-4 col-md-12 d-flex justify-content-lg-end justify-content-center">
              <div className="data-eng-card">
                <img
                  src="static/media/cloudera-partner-badge.bea6d1f0f7f1dfc2b1c8.jpg"
                  alt="cloudera"
                />
                <img src={cloudera} alt="cloudera" />
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <FooterOne></FooterOne>
    </>
  );
};

export default Data_Engineering;
